module.exports = __webpack_public_path__ + "static/media/20.b9c3ecde.jpg";